import classNames from "classnames";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import {
  container as cardWrapper,
  videoCardWrapper,
} from "~/components/storefront/InfiniteVideoCards/InfiniteVideoCards.css";
import {
  container as tabWrapper,
  tabContainer,
} from "~/components/storefront/ScrollingTabs/ScrollingTabs.css";
import { cardContainer, cardBody } from "~/components/storefront/VideoCard/VideoCard.css";

import * as styles from "./EmptySkeleton.css";

const TABS_COUNT = 12;
const CARDS_COUNT = 5;

export const EmptySkeleton = (): React.ReactElement => (
  <div className={styles.container}>
    <div className={tabWrapper}>
      <div className={tabContainer}>
        {[...Array(TABS_COUNT)].map((_, index) => (
          <Skeleton
            key={index}
            width={index % 4 === 0 ? 84 : 105}
            height={40}
            borderRadius={100}
            baseColor={"#F8F8F8"}
            enableAnimation={false}
          />
        ))}
      </div>
    </div>
    <div className={classNames(styles.videoCardContainer, cardWrapper)}>
      <div className={videoCardWrapper}>
        {[...Array(CARDS_COUNT)].map((_, index) => (
          <div key={index} className={classNames(cardContainer, styles.hideLastCard)}>
            <Skeleton
              width={"100%"}
              height={306}
              borderRadius={8}
              enableAnimation={false}
              baseColor={"#F8F8F8"}
            />
            <div className={classNames(cardBody, styles.cardGap)}>
              <Skeleton width={"100%"} height={20} enableAnimation={false} baseColor={"#F8F8F8"} />
              <Skeleton width={"80%"} height={20} enableAnimation={false} baseColor={"#F8F8F8"} />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);
